import React, { memo } from 'react';
import IconMC from '../../../components/IconMC';
import {
  callHistoryStatusBadgeClassName,
  displayedCallDuration,
  formatCompactCallStatusLabel,
  resolveCallDurationDisplay
} from '../../../hooks/calls/callHistoryDisplayMapper';

const CustomerCallCardMC = memo(({
  call,
  onView,
  tCallEvent,
  tCopy,
  copyPrefix
}) => {
  const directionLabel = call.direction === 'incoming'
    ? tCallEvent('filters.event_type.incoming_call')
    : tCallEvent('filters.event_type.outgoing_call');
  const statusLabel = formatCompactCallStatusLabel(call, tCallEvent, tCopy, copyPrefix);
  const { labelKey: durationLabelKey } = resolveCallDurationDisplay(call);
  const durationText = displayedCallDuration(call);
  const startedAt = call.started_at
    ? new Date(call.started_at).toLocaleString()
    : '';

  return (
    <div className="tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-2 tw-rounded-xl tw-border tw-border-gray-200 tw-p-3">
      <div className="tw-flex tw-flex-col tw-gap-1 tw-min-w-0 tw-flex-1">
        <span className="tw-text-xs tw-font-medium tw-text-gray-950 tw-truncate">
          {directionLabel}
        </span>
        <span className={`${callHistoryStatusBadgeClassName(call, { compact: true })} tw-self-start`}>
          {statusLabel}
        </span>
        <div className="tw-text-3xs tw-text-gray-500">
          <span className="tw-font-semibold tw-text-gray-700">
            {tCallEvent('view_call_sidebar.date_label')}
          </span>
          {' '}
          {startedAt}
        </div>
        {durationText && (
          <div className="tw-text-3xs tw-text-gray-500">
            <span className="tw-font-semibold tw-text-gray-700">
              {tCallEvent(durationLabelKey)}
            </span>
            {' '}
            {durationText}
          </div>
        )}
        <div className="tw-text-3xs tw-text-gray-500 tw-truncate">
          <span className="tw-font-semibold tw-text-gray-700">
            {tCallEvent('view_call_sidebar.agent_label')}
          </span>
          {' '}
          {call.agent?.full_name || tCallEvent('view_call_sidebar.agent_unassigned')}
        </div>
      </div>
      <button
        type="button"
        className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-p-1 tw-rounded-full hover:tw-bg-gray-100 tw-text-gray-600"
        onClick={() => onView(call)}
        title={tCallEvent('view_call_sidebar.title')}
        aria-label={tCallEvent('view_call_sidebar.title')}
      >
        <IconMC name="eye-outline" size="sm" />
      </button>
    </div>
  );
});

CustomerCallCardMC.displayName = 'CustomerCallCardMC';

export default CustomerCallCardMC;
